export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

// Client portal: single links only (no nested submenus)
const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'contractor-dashboard',
      displayName: 'Portal Dashboard',
      meta: { icon: 'mso-dashboard', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-live-tracker',
      displayName: 'Fleet Tracker',
      meta: { icon: 'mso-location_on', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-vehicles',
      displayName: 'Fleet',
      meta: { icon: 'mso-directions_car', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-drivers',
      displayName: 'Drivers',
      meta: { icon: 'mso-person', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-reports',
      displayName: 'Reports',
      meta: { icon: 'mso-description', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-team',
      displayName: 'Portal users',
      meta: { icon: 'mso-group', allowedRoles: ['client_portal'] },
    },
    {
      name: 'contractor-preferences',
      displayName: 'Settings',
      meta: { icon: 'mso-settings', allowedRoles: ['client_portal'] },
    },
  ],
}

export default sidebarRoutes
